import React from "react";
import { Link } from "react-router-dom";

export default function RelatedPostsItem({ post }) {
  const { id, image, title, tags, createAT } = post || {};
  return (
    <div className="card">
      <Link to={`/post/${id}`}>
        <img src={image} className="card-image" alt="" />
      </Link>
      <div className="p-4">
        <Link
          to={`/post/${id}`}
          className="text-lg post-title lws-RelatedPostTitle"
        >
          {title}
        </Link>
        <div className="mb-0 tags">
          {tags?.map((tag, index) => {
            const comma = index < tags.length - 1 ? ", " : "";
            return (
              <span key={index}>
                #{tag}
                {comma}
              </span>
            );
          })}
        </div>
        <p>{createAT}</p>
      </div>
    </div>
  );
}
